module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/passthrough.js
// module id = 1590
// module chunks = 2